export default "__VITE_ASSET__DkRWpOUS__"